
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 4A3.514 3.514 0 0013 7.5c0 1.922 1.578 3.5 3.5 3.5S20 9.422 20 7.5 18.422 4 16.5 4zm0 2c.84 0 1.5.66 1.5 1.5S17.34 9 16.5 9 15 8.34 15 7.5 15.66 6 16.5 6zm-7.531 4a1.99 1.99 0 00-1.625.844l-2.032 2.844-.625.906.97.531 12.655 6.938a5.501 5.501 0 00-.656.968c-.441.856-.656 1.688-.656 1.688L16.625 26H27.5l-.563-1.375s-.664-1.523-1.437-3.063c-.387-.769-.797-1.558-1.219-2.187-.21-.313-.41-.602-.656-.844-.246-.242-.54-.531-1.156-.531-.383 0-.742.18-.969.375a2.097 2.097 0 00-.469.594c-.226.398-.36.797-.5 1.156-.113.29-.246.523-.343.688l-2.813-1.532-.781-5.875A2.97 2.97 0 0015 11.156l-1.625-.812A3.024 3.024 0 0012 10zm0 2h1.625L9 14.656l-1.375-.75zm3.781.281l1.281.656L12 16.314l-1.25-.688zm2.125 3.156l.344 2.657-1.469-.813zm-7.156 2.188L6.094 26h2.031l1.438-7.375zm4.906 2.656l.375.657V26h2v-4.406zm9.938.157c.019.03.039.03.062.062.336.496.727 1.207 1.094 1.938.39.777.468 1 .718 1.562h-5c.008-.012-.007-.02 0-.031.168-.324.368-.64.532-.813.164-.172.23-.156.187-.156.711 0 1.29-.453 1.594-.875.305-.422.469-.86.625-1.25.074-.188.125-.285.188-.438z"}})])
          )
        }
      }
    